import React, { type FC } from 'react';

export const RebrandedTimeSvg: FC = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.8359 9.16927V4.16927H9.16927V10.8359H14.1693V9.16927H10.8359Z"
                fill="#161719"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.1693 10.0026C19.1693 15.0652 15.0652 19.1693 10.0026 19.1693C4.93999 19.1693 0.835938 15.0652 0.835938 10.0026C0.835938 4.93999 4.93999 0.835938 10.0026 0.835938C15.0652 0.835938 19.1693 4.93999 19.1693 10.0026ZM17.5026 10.0026C17.5026 14.1447 14.1447 17.5026 10.0026 17.5026C5.86047 17.5026 2.5026 14.1447 2.5026 10.0026C2.5026 5.86047 5.86047 2.5026 10.0026 2.5026C14.1447 2.5026 17.5026 5.86047 17.5026 10.0026Z"
                fill="#161719"
            />
        </svg>
    );
};
